import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import Markdown from "../../components/Markdown"

import style from "./index.module.css"

export default class PersonList extends React.Component {
  render() {
    var persons = this.props.limit ? this.props.persons.slice(0, (this.props.limit)) : this.props.persons;
    var link = this.props.linkTo ? this.props.linkTo : false;
    return (
      <div className={style.list}>
        {persons && persons.map((person, index) =>
          <article className={style.person} key={index}>
            {link &&
              <Link to={link}>
                {person.image &&
                  <Img className={style.image} fluid={person.image.fluid} alt={person.name} />
                }
                <div className={style.textContainer}>
                  <h1 className={style.name}>{person.name}</h1>
                  {person.omschrijving &&
                    <Markdown source={person.omschrijving.omschrijving} softBreak="br" className={style.description}/>
                  }
                </div>
              </Link>
            }
            {!link &&
              <div>
                {person.image &&
                  <Img className={style.image} fluid={person.image.fluid} alt={person.name} />
                }
                <div className={style.textContainer}>
                  {!person.jobtitle &&
                    <h1 className={style.name}>{person.name}</h1>
                  }
                  {person.jobtitle && [
                    <h1 key={person.name} className={style.nameNoMargin}>{person.name}</h1>,
                    <div key={person.jobtitle} className={style.jobtitle}>{person.jobtitle}</div>
                  ]}
                  {person.omschrijving &&
                    <Markdown source={person.omschrijving.omschrijving} softBreak="br" className={style.description}/>
                  }
                </div>
              </div>
            }
          </article>
        )}
      </div>
    )
  }
}